export default __webpack_public_path__ + "static/media/icon-share.1449c849.svg";